import { AuthSessionManager } from "@app/AuthSessionManager.ts";
import { Env } from "@app/Env.ts";
import { queryClient } from "@app/queryClient.ts";
import { createAuthSessionRefresher } from "@app/refreshAuthSession.ts";
import { createTrpcLoggerLink } from "@app/trpcLoggerLink.ts";
import { createTrpcRefreshAuthSessionLink } from "@app/trpcRefreshAuthSessionLink.ts";
import type { AppRouter } from "@server/routers/appRouter.ts";
import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { inferRouterOutputs } from "@trpc/server";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import superjson from "superjson";

export { queryClient };

export const refreshAuthSession = createAuthSessionRefresher((refreshToken) =>
  trpcClient.auth.refreshAuthSession.mutate({ refreshToken }),
);

export let trpcClient: ReturnType<typeof createTRPCClient<AppRouter>>;
trpcClient = createTRPCClient<AppRouter>({
  links: [
    createTrpcLoggerLink({
      enabled: (opts) =>
        Env.MODE === "development" ||
        (opts.direction === "down" && opts.result instanceof Error),
    }),
    createTrpcRefreshAuthSessionLink(refreshAuthSession),
    httpBatchLink({
      url: Env.SERVER_URL,
      transformer: superjson,
      headers() {
        const authToken = AuthSessionManager.getAuthToken();
        if (authToken) {
          return {
            Authorization: `Bearer ${authToken}`,
          };
        }
        return {};
      },
    }),
  ],
});

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: trpcClient,
  queryClient,
});

export type AppRouterOutput = inferRouterOutputs<AppRouter>;
